import React from 'react';
import { ActivityIndicator } from '@atomic';
import { FlexRow } from './styles';
var LoadingSpinner = function () {
    return (React.createElement(FlexRow, null,
        React.createElement(ActivityIndicator, { type: "spinner", size: "2x" })));
};
export default LoadingSpinner;
